import { Helmet } from "react-helmet-async";

const SITE_NAME = "Gensan Motors";
const BASE_URL = "https://gensanmotors.com.tr";
const DEFAULT_KEYWORDS =
  "motosiklet satış İstanbul, sıfır motor, ikinci el motor, Gensan Motors, ikinci el motosiklet İstanbul";
const DEFAULT_IMAGE = `${BASE_URL}/gensan-logo-full.png`;

export const Seo = ({ title, description, keywords, path = "", image, jsonLd }) => {
  const fullTitle = title ? `${title} | ${SITE_NAME}` : `${SITE_NAME} | Motosiklet Galerisi İstanbul`;
  const url = `${BASE_URL}${path}`;
  const kw = keywords ? `${keywords}, ${DEFAULT_KEYWORDS}` : DEFAULT_KEYWORDS;
  const img = image || DEFAULT_IMAGE;

  return (
    <Helmet>
      <title>{fullTitle}</title>
      <meta name="description" content={description} />
      <meta name="keywords" content={kw} />
      <link rel="canonical" href={url} />

      <meta property="og:type" content="website" />
      <meta property="og:site_name" content={SITE_NAME} />
      <meta property="og:title" content={fullTitle} />
      <meta property="og:description" content={description} />
      <meta property="og:url" content={url} />
      <meta property="og:image" content={img} />
      <meta property="og:locale" content="tr_TR" />

      <meta name="twitter:card" content="summary_large_image" />
      <meta name="twitter:title" content={fullTitle} />
      <meta name="twitter:description" content={description} />
      <meta name="twitter:image" content={img} />

      {jsonLd && <script type="application/ld+json">{JSON.stringify(jsonLd)}</script>}
    </Helmet>
  );
};

export default Seo;
